"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BorderOutline = {
    name: 'border',
    theme: 'outline',
    nameWithTheme: 'border-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
            },
            children: []
        }
    ]
};
exports.default = BorderOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/outline/BorderOutline.js
// module id = 880
// module chunks = 0 1